export default "__VITE_ASSET__C5JZvtnk__"